type CreateOptions = (method: string, body?: unknown) => RequestInit;

export const createOptions: CreateOptions = (method, body) => {
	const stringifiedBody = body ? JSON.stringify(body) : undefined;

	return {
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
		},
		method,
		body: stringifiedBody,
	};
};
